import EditOwner from "../../Owner/edit.vue";
import EditVehicle from "../../Common/editVehicle.vue";
import EditInsuranceReqRCA from "../../Common/editInsuranceReqRCA.vue";

export default {
    name: "CascoOffer",

    components: {
        EditOwner,
        EditVehicle,
        EditInsuranceReqRCA
    },

    props: {},

    data: () => {
        return {
            orderSettings: {
                JsonSettings: {
                    PropertyType: 1
                }
            }
        };
    },

    computed: {},

    methods: {
        validate: function() {
            var ownerIsValid = this.$refs.editOwner.validate();
            let vehicleIsValid = true;
            if (this.orderSettings.JsonSettings.PropertyType == 1) {
                vehicleIsValid = this.$refs.editVehicle.validate();
            }
            let result = vehicleIsValid && ownerIsValid;

            return result;
        }
    }
};
